/* Fiche produit MonSacPoubelle — moteur de la buy-box « Config express » :
   paliers cliquables ↔ quantité, prix TTC/HT (mode Particulier/Pro), prix au sac,
   ajout au panier AJAX (drawer), galerie, barre sticky mobile.
   Les prix de cette section ne portent pas les classes Dawn (.price-item--*) :
   msp-price-per-bag.js ne les touche pas, tout est peint ici. */
(function () {
  'use strict';
  if (window.__mspProductJs) return;
  window.__mspProductJs = true;

  var TVA = 1.2;

  function fmt(cents) {
    return (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function init(root) {
    if (root.dataset.mspInit) return;
    root.dataset.mspInit = '1';

    var base = parseInt(root.dataset.baseCents, 10) || 0;
    var bags = parseInt(root.dataset.bags, 10) || 0;
    var variantId = root.dataset.variantId;
    var qtyInput = root.querySelector('[data-msp-pp-qty]');
    var stickyBar = root.querySelector('[data-msp-pp-sticky]');
    var tiers = Array.prototype.map.call(root.querySelectorAll('[data-msp-pp-tier]'), function (el) {
      return { el: el, qty: parseInt(el.dataset.qty, 10) || 1, pct: parseFloat(el.dataset.pct) || 0 };
    });

    function mode() {
      return window.MSP && window.MSP.getMode ? window.MSP.getMode() : 'particulier';
    }

    function tierFor(qty) {
      var best = { qty: 1, pct: 0, el: null };
      tiers.forEach(function (t) {
        if (qty >= t.qty && t.pct >= best.pct) best = t;
      });
      return best;
    }

    function displayCents(cents) {
      return mode() === 'pro' ? Math.round(cents / TVA) : cents;
    }

    function suffix() {
      return mode() === 'pro' ? ' HT' : ' TTC';
    }

    function setText(sel, text) {
      var el = root.querySelector(sel);
      if (el) el.textContent = text;
    }

    function paint() {
      var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      var current = tierFor(qty);
      var carton = Math.round(base * (1 - current.pct / 100));
      var cartonDisp = displayCents(carton);
      var perBag = bags ? cartonDisp / bags : 0;

      if (bags) {
        setText('[data-msp-pp-perbag]', (perBag / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €');
      }
      setText('[data-msp-pp-carton]', fmt(cartonDisp) + suffix() + ' le carton' + (bags ? ' de ' + bags + ' sacs' : ''));
      var altCents = mode() === 'pro' ? carton : Math.round(carton / TVA);
      setText('[data-msp-pp-alt]', mode() === 'pro' ? 'soit ' + fmt(carton) + ' TTC' : 'soit ' + fmt(altCents) + ' HT');

      tiers.forEach(function (t) {
        var tCarton = displayCents(Math.round(base * (1 - t.pct / 100)));
        var p = t.el.querySelector('[data-tier-perbag]');
        var c = t.el.querySelector('[data-tier-carton]');
        if (p && bags) p.textContent = (tCarton / bags / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €/sac';
        if (c) c.textContent = fmt(tCarton) + suffix();
        var tot = t.el.querySelector('[data-tier-total]');
        if (tot) tot.textContent = fmt(tCarton * t.qty) + suffix();
        t.el.classList.toggle('is-active', t === current || (current.pct === 0 && t.pct === 0));
        t.el.setAttribute('aria-pressed', t === current ? 'true' : 'false');
      });

      var total = displayCents(carton) * qty;
      root.querySelectorAll('[data-msp-pp-cta-price]').forEach(function (el) {
        el.textContent = fmt(total) + suffix();
      });
      var stickyPrice = stickyBar && stickyBar.querySelector('[data-msp-pp-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = fmt(total) + suffix();
      var stickySub = stickyBar && stickyBar.querySelector('[data-msp-pp-sticky-sub]');
      if (stickySub && bags) {
        stickySub.textContent = qty + ' carton' + (qty > 1 ? 's' : '') + ' · ' + (perBag / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €/sac';
      }
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-msp-pp-avis]')) {
        var avis = document.querySelector('.msp-reviews');
        if (avis) avis.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      var tier = e.target.closest('[data-msp-pp-tier]');
      if (tier) {
        qtyInput.value = tier.dataset.qty;
        paint();
        return;
      }
      var minus = e.target.closest('[data-msp-pp-minus]');
      var plus = e.target.closest('[data-msp-pp-plus]');
      if (minus || plus) {
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, v + (plus ? 1 : -1));
        paint();
      }
    });
    if (qtyInput) qtyInput.addEventListener('change', paint);
    window.addEventListener('msp:mode-change', paint);

    /* Ajout au panier — même mécanique que les cartes (drawer). */
    root.querySelectorAll('[data-msp-pp-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
        btn.disabled = true;
        var drawer = document.querySelector('cart-drawer');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variantId,
            quantity: qty,
            sections: drawer ? 'cart-drawer,cart-icon-bubble' : undefined,
            sections_url: window.location.pathname
          })
        })
          .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
          .then(function (data) {
            var label = btn.querySelector('[data-add-label]');
            var done = btn.querySelector('[data-add-done]');
            if (label) label.hidden = true;
            if (done) done.hidden = false;
            btn.classList.add('is-done');
            if (drawer && data.sections && typeof drawer.renderContents === 'function') {
              drawer.renderContents({ sections: data.sections });
            }
            setTimeout(function () {
              if (label) label.hidden = false;
              if (done) done.hidden = true;
              btn.classList.remove('is-done');
              btn.disabled = false;
            }, 1600);
          })
          .catch(function () { btn.disabled = false; });
      });
    });

    /* Galerie : vignettes ↔ bande scroll-snap (pas de zoom au clic). */
    var strip = root.querySelector('[data-msp-pp-strip]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-msp-pp-thumb]'));
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-msp-pp-slide]'));
    function activateThumb(i) {
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', i === j); });
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        if (strip && slides[i]) strip.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
        activateThumb(i);
      });
    });
    if (strip) {
      var stripPending = null;
      strip.addEventListener('scroll', function () {
        clearTimeout(stripPending);
        stripPending = setTimeout(function () {
          var i = Math.round(strip.scrollLeft / Math.max(1, strip.clientWidth));
          activateThumb(Math.min(slides.length - 1, Math.max(0, i)));
        }, 80);
      }, { passive: true });
    }
    /* Sticky mobile : visible quand le CTA principal est sorti par le haut.
       Écouteur scroll passif (IntersectionObserver est gelé dans certains
       contextes — onglets throttlés — et son état initial n'est pas garanti). */
    var sticky = stickyBar;
    var mainCta = root.querySelector('[data-msp-pp-add]');
    if (sticky && mainCta) {
      /* Sortie de tout contexte de section : un ancêtre avec transform
         (animations Dawn) transformerait le position:fixed en absolute. */
      document.querySelectorAll('body > [data-msp-pp-sticky]').forEach(function (b) { b.remove(); });
      document.body.appendChild(sticky);
      var mq = window.matchMedia('(max-width: 749px)');
      var checkSticky = function () {
        var show = mq.matches && mainCta.getBoundingClientRect().bottom < 0;
        sticky.classList.toggle('is-visible', show);
        document.documentElement.classList.toggle('msp-sticky-on', show);
      };
      window.addEventListener('scroll', checkSticky, { passive: true });
      window.addEventListener('resize', checkSticky, { passive: true });
      checkSticky();
    }

    paint();
  }

  function boot() {
    document.querySelectorAll('[data-msp-pp]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
